const LOCAL_STORAGE_CURRENT_ORG_KEY = 'CFS_CURRENT_ORG_ID';

export const useOrganization = () => {
  const getCurrentOrgFromLocalStorage = () => localStorage.getItem(LOCAL_STORAGE_CURRENT_ORG_KEY);
  const setCurrentOrgInLocalStorage = (id: string | undefined) =>
    id
      ? localStorage.setItem(LOCAL_STORAGE_CURRENT_ORG_KEY, id)
      : localStorage.removeItem(LOCAL_STORAGE_CURRENT_ORG_KEY);

  return { getCurrentOrgFromLocalStorage, setCurrentOrgInLocalStorage };
};
